
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvv",
      function () {
        return require("private-next-pages/mvv.tsx");
      }
    ]);
  